import React from 'react';
import { Star } from 'lucide-react';
import { TESTIMONIALS } from '../mock';

export default function Testimonials() {
  return (
    <section id="gaestestimmen" className="relative py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="reveal max-w-3xl mb-14">
          <div className="flex items-center gap-4 mb-6">
            <span className="h-px w-12 bg-[rgba(224,180,159,0.6)]" />
            <span className="eyebrow">04 — Gästestimmen</span>
          </div>
          <h2 className="font-serif-display font-medium text-[#f2ebe3] text-4xl md:text-6xl leading-[1.05]">
            Was unsere Gäste <span className="italic text-[#e0b49f]">erzählen.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="reveal rounded-2xl border border-[rgba(224,180,159,0.15)] bg-[#1c1712] p-8 flex flex-col hover:border-[rgba(224,180,159,0.4)] transition-colors duration-500"
            >
              <div className="flex items-center gap-1 mb-5">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} size={16} className="text-[#e0b49f] fill-[#e0b49f]" />
                ))}
              </div>
              <p className="font-serif-display italic text-[#e6ddd2] text-xl leading-relaxed flex-1">
                „{t.text}“
              </p>
              <div className="mt-6 flex items-center gap-3">
                <span className="h-px w-8 bg-[#e0b49f]" />
                <span className="text-[#c3b7aa] text-sm tracking-wide uppercase">{t.name}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
